import { useCallback, useContext, useEffect, useMemo } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { ReactComponent as AddIcon } from 'assets/icons/Add.svg';
import { SvgIcon } from '@mui/material';
import { app } from "router/routes";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { actions } from "store";
import { alerts, features, roles } from "keys";
import { AbilityContext } from "components/Permissions/Can";
import { affiliationsHooks } from "pages/School/Affiliations";
import { SchoolContext } from "../SchoolContext";
import AffiliationCrud from '../AffiliationCrud'
import AffiliationTeam from '../AffiliationTeam'
import PromoteClassControls from '../PromoteClassControls'
import { permissions } from "config/ability";

const useTabs = () => {
    const schoolContext = useContext(SchoolContext)
    const { isSchoolsGroup, affiliationGroupItem, affiliation } = schoolContext || {}
    const { affiliationID } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const ability = useContext(AbilityContext)
    const canReadAffiliationDetails = ability.can(permissions.read, features.school_setup)
    const groupByName = affiliationsHooks.useAffiliationGroupItems()

    const affiliationGroupUIItem = groupByName[affiliation?.data?.group_name]

    const { } = useMutation({

    })

    const addNewUser = useCallback(() => {
        navigate(`${app.affiliations}/${affiliationID}/staff/new`)
    }, [affiliationID])

    const addNewLearningUnit = useCallback(() => {
        // מותאם עבור יחידות למידה מסוג בית ספר ויחיות למידה חוץ בית ספר
        dispatch(actions.setAlerts({
            key: affiliationGroupUIItem.alertKey,
            value: {
                open: true,
                props: {
                    affiliation: affiliationID
                }
            }
        }))
    }, [affiliationID, affiliationGroupUIItem])

    const tabs = useMemo(() => [
        {
            index: 0,
            component: AffiliationCrud,
            label: isSchoolsGroup ? "פרטי בית הספר" : "פרטי הלקוח",
            headerBtns: [],
            overflow: true
        },
        {
            disabled: !affiliationID,
            index: 1,
            component: affiliationGroupUIItem?.LearningUnitComponent,
            label: "מצבת תלמידים",
            headerBtns: [],
            overflow: false,
            headerBtns: [
                {
                    icon: <SvgIcon component={AddIcon} inheritViewBox />,
                    label: affiliationGroupUIItem?.createClassLabel,
                    action: addNewLearningUnit
                }
            ],
            // "העלאת כיתה": DD לבחירת שנת לימודים לצפייה + כפתור ליצירה/העלאה של מה שנבחר
            headerExtra: isSchoolsGroup ? <PromoteClassControls /> : null
        },
        {
            index: 2,
            disabled: !affiliationID,
            component: AffiliationTeam,
            label: "צוות",
            headerBtns: [
                {
                    icon: <SvgIcon component={AddIcon} inheritViewBox />,
                    label: "הוספת איש צוות",
                    action: addNewUser
                }
            ],
            overflow: false
        }
    ], [affiliation, isSchoolsGroup, affiliationID, affiliationGroupUIItem])

    return canReadAffiliationDetails ? tabs : [tabs[1]]
}

export default useTabs